// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__1Lht_","fadeIn":"Modal_fadeIn__g1VD-","content":"Modal_content__3NjRe","close":"Modal_close__2u7wz"};